import React from "react";

interface ThreeDotLoaderProps {
  size?: "small" | "large"; // Standardize size prop
  position?: "inline" | "center"; // Control positioning (for search or full-page loaders)
}

export default function ThreeDotLoader({
  size = "large",
  position = "center",
}: ThreeDotLoaderProps) {
  const dotSizeClasses = size === "small" ? "lg:h-3 lg:w-3" : "lg:h-4 lg:w-4";

  return (
    <div
      className={` ${
        position === "inline" ? "my-6 lg:my-4" : "absolute inset-0"
      } flex justify-center items-center`}
    >
      <style>{`
        @keyframes progress {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .animate-progress {
          animation: progress 1.2s linear infinite;
        }

        .animate-progress:nth-child(1) {
          animation-delay: 0s;
        }

        .animate-progress:nth-child(2) {
          animation-delay: 0.3s;
        }

        .animate-progress:nth-child(3) {
          animation-delay: 0.6s;
        }
      `}</style>
      <div className="flex space-x-1 lg:space-x-2">
        <div
          className={`${dotSizeClasses} h-2 w-2 bg-primary rounded-full animate-progress`}
        ></div>
        <div
          className={`${dotSizeClasses} h-2 w-2 bg-primary rounded-full animate-progress`}
        ></div>
        <div
          className={`${dotSizeClasses} h-2 w-2 bg-primary rounded-full animate-progress`}
        ></div>
      </div>
    </div>
  );
}
